export default "/images/358300748703e6f680f76b1eb9e1c1a9.avif";